import { getLocalItem, setLocalItem } from './storage';
import { useRouter } from 'next/router';

export type UTMParams = {
  af_channel: string;
  c: string;
  offer: string;
  pid: string;
  utm_campaign: string;
  utm_content: string;
  utm_medium: string;
  utm_source: string;
  utm_term: string;
};

const utmKeys: (keyof UTMParams)[] = [
  'af_channel',
  'c',
  'offer',
  'pid',
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
];

export const useUtmParams = (): Partial<UTMParams> => {
  const router = useRouter();
  const { query } = router;
  const utmParams: Partial<UTMParams> = {};

  // Check if query param is one of our UTM keys and extract it from query into params
  for (const [key, value] of Object.entries(query)) {
    if (typeof value === 'string' && utmKeys.includes(key as keyof UTMParams)) {
      setLocalItem(key, value);
      utmParams[key as keyof UTMParams] = value;
    }
  }

  // Check to see if there are any UTM params already in SessionStorage
  const checkForStoredParams = async () => {
    for (const key of utmKeys) {
      const value = await getLocalItem(key);
      if (value && !utmParams[key]) utmParams[key] = value;
    }
  };

  // This is defined/called like this to allow it to be used async within hooks
  checkForStoredParams();

  return utmParams;
};
